import { CoreIcon } from '../core-icon';
import mapPinFillSVG from '../../assets/icons/map-pin-fill.svg';
import type { IconProps } from '../core-icon';

export const MapPinFillIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={mapPinFillSVG} {...props} />;
};
